module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.showHead) ? _c('div', {
    class: (_vm.prefixCardClass + "-header")
  }, [_vm._t("head")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: (_vm.prefixCardClass + "-block")
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    class: (_vm.prefixCardClass + "-footer")
  }, [_vm._t("foot")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69d3986a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/card.vue
// module id = 381
// module chunks = 0